export class ContasPagarBulkAlterarFormaPagamentoRequest {
    public idsParcelas: number[] = [];
    public idFormaPagamento: number;
}
